import React, { useEffect, useState } from "react";
// import { useParams } from 'react-router-dom';
import right from '../img/right.svg'
import copy from '../img/copy.svg'
import { useSearchParams } from 'react-router-dom';

const PaymentSuccess = () => {
  // const orderId = useSelector((state) => state.data.orderID);
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('orderId');
  // const { id, orderId } = useParams();
  const [copyStatus, setCopyStatus] = useState(false)
  const handleCopy = () => {
    navigator.clipboard.writeText(orderId)
      .then(() => setCopyStatus(true))
      .catch(err => console.error("Copy Failed ", err));
  };

  useEffect(()=>{
    if(copyStatus){
      const timer = setTimeout(() => {
        setCopyStatus(false);
      }, 3000);
      return () => clearTimeout(timer); 
    }
  },[copyStatus])
  return (
    <div className="p-10 border-b-2 border-gray-200">
      <div className="flex flex-col items-center text-center">
        <div className="flex items-center space-x-2">
          <img src={right} className="w-8 h-8" alt="payment-success-icon" />
          <span className="text-green-500 text-lg font-bold uppercase">Thank you for your payment!</span>
        </div>
        <div className="font-bold flex cursor-pointer my-5" onClick={handleCopy}>Order ID:&nbsp;{orderId}&nbsp;
          {!copyStatus ? (
            <img src={copy} className="w-6" alt='copy' />
          ) : (
            <p className="text-red-500">Copy Successful!</p>
          )}
        </div>
        <div className="">
          <p className="text-md text-gray-800">Your rental details and order number will be sent to your email shortly. <br />
            If you don't receive it within five minutes, please check your spam folder.</p>
          <p className=" text-sm text-gray-500">You can also search for your order using the search feature in the top right corner.</p>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
